import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Common } from 'src/app/common/common';
import * as XLSX from 'xlsx';
import { ClearEvent, FileRestrictions, RemoveEvent, SelectEvent } from '@progress/kendo-angular-upload';
import { IAgreementImportModel, IDocumentImportModel } from 'src/app/interface/IDataMigration';
import { AwardInfoService } from 'src/app/service/award-information/award-info.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
  selector: 'app-data-migration',
  templateUrl: './data-migration.component.html',
  styleUrls: ['./data-migration.component.scss']
})
export class DataMigrationComponent implements OnInit {

  constructor(private awardInfoService: AwardInfoService, private notificationService: NotificationService) { }

  public masterDataUploadForm: FormGroup;
  public file: any = '';
  public jsonString: string;
  public arrayBuffer: any;
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: ['.xlsx']
  };
  public dataz: IAgreementImportModel[];
  public deliverableDetailList: any;
  public enableUploadButton: boolean = false;
  // Document Import
  public documentFile: any = '';
  public documentJsonString: string;
  public documentDataz: IDocumentImportModel = {};
  public enableDocumentUploadButton: boolean = false;


  ngOnInit(): void {
  }

  public selectEventHandler(event: SelectEvent): void {
    if (event.files && event.files.length > 0) {
      if (!event.files[0].validationErrors) {
        this.file = event.files[0].rawFile;
        this.enableUploadButton = true;
        const fileReader = new FileReader();
        Common.loader('show');
        fileReader.onload = (e) => {
          Common.loader('show');
          this.arrayBuffer = fileReader.result;
          const data1 = new Uint8Array(this.arrayBuffer);
          const arr = new Array();
          for (let i = 0; i !== data1.length; ++i) {
            arr[i] = String.fromCharCode(data1[i]);
          }

          const bstr = arr.join('');
          const workbook = XLSX.read(bstr, { type: 'binary' });
          // award
          const sheetOne = workbook.SheetNames[0];
          const worksheet1 = workbook.Sheets[sheetOne];
          const awardEntry: any = XLSX.utils.sheet_to_json(worksheet1, { raw: true, defval: '' });
          // donor Contacts
          const sheetTwo = workbook.SheetNames[1];
          const worksheet2 = workbook.Sheets[sheetTwo];
          const donorContacts: any = XLSX.utils.sheet_to_json(worksheet2, { raw: true, defval: '' });
          // technical Areas
          const sheetThree = workbook.SheetNames[2];
          const worksheet3 = workbook.Sheets[sheetThree];
          const technicalAreas: any = XLSX.utils.sheet_to_json(worksheet3, { raw: true, defval: '' });
          // countrys
          const sheetFour = workbook.SheetNames[3];
          const worksheet4 = workbook.Sheets[sheetFour];
          const countrys: any = XLSX.utils.sheet_to_json(worksheet4, { raw: true, defval: '' });
          // region
          const sheetFive = workbook.SheetNames[4];
          const worksheet5 = workbook.Sheets[sheetFive];
          const region: any = XLSX.utils.sheet_to_json(worksheet5, { raw: true, defval: '' });
          // country Implementations
          const sheetSix = workbook.SheetNames[5];
          const worksheet6 = workbook.Sheets[sheetSix];
          const countryImplementations: any = XLSX.utils.sheet_to_json(worksheet6, { raw: true, defval: '' });
          // deliverables
          const sheetSeven = workbook.SheetNames[6];
          const worksheet7 = workbook.Sheets[sheetSeven];
          const deliverables: any = XLSX.utils.sheet_to_json(worksheet7, { raw: true, defval: '' });
          // deliverable Details
          const sheetEight = workbook.SheetNames[7];
          const worksheet8 = workbook.Sheets[sheetEight];
          const deliverableDetails: any = XLSX.utils.sheet_to_json(worksheet8, { raw: true, defval: '' });
          // prior Approvals
          const sheetnine = workbook.SheetNames[8];
          const worksheet9 = workbook.Sheets[sheetnine];
          const priorApprovals: any = XLSX.utils.sheet_to_json(worksheet9, { raw: true, defval: '' });
          // notes
          const sheetTen = workbook.SheetNames[9];
          const worksheet10 = workbook.Sheets[sheetTen];
          const notes: any = XLSX.utils.sheet_to_json(worksheet10, { raw: true, defval: '' });
          // Donor
          const sheetEleven = workbook.SheetNames[10];
          const worksheet11 = workbook.Sheets[sheetEleven];
          const donor: any = XLSX.utils.sheet_to_json(worksheet11, { raw: true, defval: '' });
          // DonorContacts
          const sheetTwelve = workbook.SheetNames[11];
          const worksheet12 = workbook.Sheets[sheetTwelve];
          const masterDonorContact: any = XLSX.utils.sheet_to_json(worksheet12, { raw: true, defval: '' });

          this.dataz = awardEntry;
          this.dataz.forEach((element) => {
            element.donorContacts = [];
            element.technicalAreas = [];
            element.countryRegion = [];
            element.countryImplementation = [];
            element.priorApprovals = [];
            element.agreementNotes = [];

            if (Number.isInteger(element.projectCloseDate)) {
              element.projectCloseDate = this.convertDate(this.excelDateToJSDate(element.projectCloseDate)).toString();
            }
            if (Number.isInteger(element.projectStartDate)) {
              element.projectStartDate = this.convertDate(this.excelDateToJSDate(element.projectStartDate)).toString();
            }
            if (Number.isInteger(element.createdDate)) {
              element.createdDate = this.convertDate(this.excelDateToJSDate(element.createdDate)).toString();
            }
            if (Number.isInteger(element.lastModifiedDate)) {
              element.lastModifiedDate = this.convertDate(this.excelDateToJSDate(element.lastModifiedDate)).toString();
            }
            if (Number.isInteger(element.howManyYears)) {
              element.howManyYears = element.howManyYears.toString();
            }
            if (Number.isInteger(element.donorAwardNumber)) {
              element.donorAwardNumber = element.donorAwardNumber.toString();
            }
            if (Number.isInteger(element.egpafAwardNumber)) {
              element.egpafAwardNumber = element.egpafAwardNumber.toString();
            }
            if (element.awardTitle) {
              element.awardTitle = JSON.stringify(element.awardTitle).replace(/(?:\\[rn])+/g, '');
              element.awardTitle = element.awardTitle.replace(/"/g, '');
            }

            // Donor Contacts
            const donorContact = donorContacts.filter((el) => el.awardTitle === element.awardTitle);
            if (donorContact) {
              element.donorContacts = donorContact;
            }
            // Technicalareas
            const technicalArea = technicalAreas.filter((el) => el.awardTitle === element.awardTitle);
            if (technicalArea) {
              technicalArea.forEach((ele) => {
                if (Number.isInteger(ele.technicalAreaName)) {
                  ele.technicalAreaName = ele.technicalAreaName.toString();
                }
              });
              element.technicalAreas = technicalArea;
            }
            // Country
            const country = countrys.filter((el) => el.awardTitle === element.awardTitle);
            if (country) {
              element.countryRegion = country;
            }
            // region
            const regions = region.filter((el) => el.awardTitle === element.awardTitle);
            if (regions) {
              element.region = regions;
            }
            // Country Implementations
            const countryImplementation = countryImplementations.filter((el) => el.awardTitle === element.awardTitle);
            if (countryImplementation) {
              element.countryImplementation = countryImplementation;
            }
            // Deliverables
            const deliverable = deliverables.filter((el) => el.awardTitle === element.awardTitle);
            if (deliverable) {
              this.deliverableDetailList = [];
              deliverable.forEach((ele) => {
                const deliverableDetail = deliverableDetails.filter((el) => el.title === ele.title && el.awardTitle === ele.awardTitle);
                if (Number.isInteger(ele.awardYear)) {
                  ele.awardYear = ele.awardYear.toString();
                }
                if (Number.isInteger(ele.deliverableType)) {
                  ele.deliverableType = ele.deliverableType.toString();
                }
                // Deliverable Details
                if (deliverableDetail.length > 0) {
                  for (var i = 0; i < deliverableDetail.length; i++) {
                    this.deliverableDetailList.push(deliverableDetail[i]);
                  }
                  this.deliverableDetailList.forEach((el) => {
                    if (Number.isInteger(el.dueDate)) {
                      el.dueDate = this.convertDate(this.excelDateToJSDate(el.dueDate)).toString();
                    }
                    if (Number.isInteger(el.completedDate)) {
                      el.completedDate = this.convertDate(this.excelDateToJSDate(el.completedDate)).toString();
                    }
                    if (Number.isInteger(el.periodValue)) {
                      el.periodValue = el.periodValue.toString();
                    }
                  });
                }
              });
              element.deliverables = deliverable;
              element.deliverableDetail = this.deliverableDetailList;
            }
            // Prior Approvals
            const priorApproval = priorApprovals.filter((el) => el.awardTitle === element.awardTitle);
            if (priorApproval) {
              priorApproval.forEach((el) => {
                if (Number.isInteger(el.dateApprovalRequested)) {
                  el.dateApprovalRequested = this.convertDate(this.excelDateToJSDate(el.dateApprovalRequested)).toString();
                }
                if (Number.isInteger(el.dateApprovalReceived)) {
                  el.dateApprovalReceived = this.convertDate(this.excelDateToJSDate(el.dateApprovalReceived)).toString();
                }
                if (Number.isInteger(el.awardYear)) {
                  el.awardYear = el.awardYear.toString();
                }
                if (Number.isInteger(el.actionRequiringApproval)) {
                  el.actionRequiringApproval = el.actionRequiringApproval.toString();
                }
              });
              element.priorApprovals = priorApproval;
            }
            // Notes
            const note = notes.filter((el) => el.awardTitle === element.awardTitle);
            if (note) {
              note.forEach((res) => {
                if (Number.isInteger(res.awardYear)) {
                  res.awardYear = res.awardYear.toString();
                }
              });
              element.agreementNotes = note;
            }

            // Master Donor
            const donors = donor;
            if (donors) {
              donors.forEach((el) => {
                if (Number.isInteger(el.createdDate)) {
                  el.createdDate = this.convertDate(this.excelDateToJSDate(el.createdDate)).toString();
                }
                if (Number.isInteger(el.lastModifiedDate)) {
                  el.lastModifiedDate = this.convertDate(this.excelDateToJSDate(el.lastModifiedDate)).toString();
                }
                if (Number.isInteger(el.zip)) {
                  el.zip = el.zip.toString();
                }
                if (Number.isInteger(el.address1)) {
                  el.address1 = el.address1.toString();
                }
                if (Number.isInteger(el.address2)) {
                  el.address2 = el.address2.toString();
                }
                if (Number.isInteger(el.address3)) {
                  el.address3 = el.address3.toString();
                }
              });
              element.donor = donors;
            }

            // Master DonorContacts
            const masterDonorContacts = masterDonorContact;
            if (masterDonorContacts) {
              masterDonorContacts.forEach((el) => {
                if (Number.isInteger(el.createdDate)) {
                  el.createdDate = this.convertDate(this.excelDateToJSDate(el.createdDate)).toString();
                }
                if (Number.isInteger(el.lastModifiedDate)) {
                  el.lastModifiedDate = this.convertDate(this.excelDateToJSDate(el.lastModifiedDate)).toString();
                }
                if (Number.isInteger(el.zip)) {
                  el.zip = el.zip.toString();
                }
                if (Number.isInteger(el.phone)) {
                  el.phone = el.phone.toString();
                }
              });
              element.donorContact = masterDonorContacts;
            }

          });
          this.jsonString = JSON.stringify(this.dataz);
          Common.loader('hide');
        };
        fileReader.readAsArrayBuffer(this.file);
      } else {
        this.file = '';
      }
    } else {
      this.enableUploadButton = false;
    }
  }

  public uploadMasterData() {
    Common.loader('show');
    this.awardInfoService.postDataMigration(this.jsonString).subscribe((response: any) => {
      if (response) {
        this.show();
      } else {
        Common.loader('hide');
      }
    });
  }

  convertDate(inputFormat) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    const d = new Date(inputFormat);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-') + ' ' +
      [pad(d.getHours()),
      pad(d.getMinutes()),
      pad(d.getSeconds())].join(':');
  }

  excelDateToJSDate(serial) {
    const utcDays = Math.floor(serial - 25569);
    const utcValue = utcDays * 86400;
    const dateInfo = new Date(utcValue * 1000);
    const fractionalDay = serial - Math.floor(serial) + 0.0000001;
    let totalSeconds = Math.floor(86400 * fractionalDay);
    const seconds = totalSeconds % 60;
    totalSeconds -= seconds;
    const hours = Math.floor(totalSeconds / (60 * 60));
    const minutes = Math.floor(totalSeconds / 60) % 60;
    return new Date(dateInfo.getFullYear(), dateInfo.getMonth(), dateInfo.getDate(), hours, minutes, seconds);
  }

  public clearEventHandler(e: ClearEvent): void {
    this.file = '';
  }

  public removeEventHandler(e: RemoveEvent): void {
    this.file = '';
  }

  public selectDocumentEventHandler(event: SelectEvent): void {
    if (event.files && event.files.length > 0) {
      if (!event.files[0].validationErrors) {
        this.documentFile = event.files[0].rawFile;
        this.enableDocumentUploadButton = true;
        const documentFileReader = new FileReader();
        documentFileReader.onload = (e) => {
          Common.loader('show');
          this.arrayBuffer = documentFileReader.result;
          const data1 = new Uint8Array(this.arrayBuffer);
          const arr = new Array();
          for (let i = 0; i !== data1.length; ++i) {
            arr[i] = String.fromCharCode(data1[i]);
          }

          const bstrs = arr.join('');
          const documentWorkbook = XLSX.read(bstrs, { type: 'binary' });
          // Documents
          const document1 = documentWorkbook.SheetNames[0];
          const documentSheet1 = documentWorkbook.Sheets[document1];
          const agreementDocuments: any = XLSX.utils.sheet_to_json(documentSheet1, { raw: true, defval: '' });

          // Agreement Documents
          const agreementDocument = agreementDocuments;
          if (agreementDocument) {
            agreementDocument.forEach((el) => {
              if (Number.isInteger(el.awardNumber)) {
                el.awardNumber = el.awardNumber.toString();
              }
              if (Number.isInteger(el.awardYear)) {
                el.awardYear = el.awardYear.toString();
              }
              if (Number.isInteger(el.documentTypeId)) {
                el.documentTypeId = el.documentTypeId.toString();
              }
              if (Number.isInteger(el.deliverableDetailDueDate)) {
                el.deliverableDetailDueDate = this.convertDate(this.excelDateToJSDate(el.deliverableDetailDueDate)).toString();
              }
              if (Number.isInteger(el.deliverableDetailCompletedDate)) {
                el.deliverableDetailCompletedDate = this.convertDate(this.excelDateToJSDate(el.deliverableDetailCompletedDate)).toString();
              }
              if (Number.isInteger(el.createdDate)) {
                el.createdDate = this.convertDate(this.excelDateToJSDate(el.createdDate)).toString();
              }
              if (Number.isInteger(el.lastModifiedDate)) {
                el.lastModifiedDate = this.convertDate(this.excelDateToJSDate(el.lastModifiedDate)).toString();
              }
            });
            this.documentDataz = agreementDocument;
          }
          this.documentJsonString = JSON.stringify(agreementDocument);
          Common.loader('hide');
        };
        documentFileReader.readAsArrayBuffer(this.documentFile);
      } else {
        this.file = '';
      }
    } else {
      this.enableDocumentUploadButton = false;
    }
  }

  public uploadDocumentData() {
    Common.loader('show');
    this.awardInfoService.documentDataMigration(this.documentJsonString).subscribe((response: any) => {
      if (response) {
        this.show();
      } else {
        Common.loader('hide');
      }
    });
  }

  public clearDocumentEventHandler(e: ClearEvent): void {
    this.documentFile = '';
  }

  public removeDocumentEventHandler(e: RemoveEvent): void {
    this.documentFile = '';
  }

  public show() {
    Common.loader('hide');
    this.notificationService.show({
      content: 'Migrated Successfuly.',
      position: { horizontal: 'center', vertical: 'bottom' },
      animation: { type: 'fade', duration: 800 },
      type: { style: 'success', icon: true },
      hideAfter: 5000,
    });
  }

}
